import React, { useState, useRef, useEffect } from "react";
import "./ContactForm.css";
// import Footer from "../components/Footer";
import { useLanguage } from "../i18n/LanguageContext";


function ContactForm() {
  const { t } = useLanguage();
  const [form, setForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    purpose: "Partnership",
    message: "",
    copy: false,
  });

  // Ссылки на все поля
  const nameRef = useRef(null);
  const companyRef = useRef(null);
  const emailRef = useRef(null);
  const phoneRef = useRef(null);
  const purposeRef = useRef(null);
  const messageRef = useRef(null);

  useEffect(() => {
    nameRef.current?.focus();
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(
        "https://98lqeqwsoj.execute-api.eu-west-1.amazonaws.com/contact",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const result = await response.json();
      console.log(result);


      if (response.ok) {
        alert(t("contact.success"));
      } else {
        alert(t("contact.error"));
      }
    } catch (error) {
      alert(t("contact.error"));
    }
  };

  return (
    <div className="contact-page">
      <div className="background-layer"></div>

      <div className="content-wrapper">
        <div className="contact-form-wrapper">
          <form className="contact-form" onSubmit={handleSubmit} autoComplete="off">
            <h2>{t("contact.title")}</h2>
            <p>{t("contact.subtitle")}</p>

            <div className="input-row">
              <input
                ref={nameRef}
                type="text"
                name="name"
                placeholder={t("contact.name")}
                value={form.name}
                onChange={handleChange}
                required
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    companyRef.current?.focus();
                  }
                }}
              />
              <input
                ref={companyRef}
                type="text"
                name="company"
                placeholder={t("contact.company")}
                value={form.company}
                onChange={handleChange}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    emailRef.current?.focus();
                  }
                }}
              />
            </div>

            <div className="input-row">
            <input
                ref={emailRef}
                type="email"
                name="email"
                autoComplete="off"
                autoCapitalize="off"
                autoCorrect="off"
                placeholder={t("contact.email")}
                value={form.email}
                onChange={handleChange}
                required
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                    e.preventDefault();
                    phoneRef.current?.focus();
                    }
                }}
                />
              <input
  ref={phoneRef}
  name="phone"
  type="text"
  inputMode="tel"
//   pattern="[0-9+]*"
  placeholder={t("contact.phone")}
  value={form.phone}
  onChange={handleChange}
  autoComplete="off"
  enterKeyHint="next"
  onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      purposeRef.current?.focus();
    }
  }}
/>
            </div>

            <select
              ref={purposeRef}
              name="purpose"
              value={form.purpose}
              onChange={handleChange}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  messageRef.current?.focus();
                }
              }}
            >
              <option value="Partnership">{t("contact.purpose.partnership")}</option>
              <option value="Supply">{t("contact.purpose.supply")}</option>
              <option value="Distribution">{t("contact.purpose.distribution")}</option>
              <option value="General">{t("contact.purpose.general")}</option>
            </select>

            <textarea
              ref={messageRef}
              name="message"
              placeholder={t("contact.message")}
              rows="6"
              value={form.message}
              onChange={handleChange}
              // ⛔ НЕ добавляем onKeyDown — Enter работает как новая строка
            ></textarea>

            <div className="checkbox-and-button">
              {/* 
              <label>
                Send me a copy of this message
                <input
                  type="checkbox"
                  name="copy"
                  checked={form.copy}
                  onChange={handleChange}
                />
              </label> 
              */}
              <button type="submit">{t("contact.submit")}</button>
            </div>
          </form>
        </div>
        
      </div>
    </div>
  );
}

export default ContactForm;
